"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2Methods = exports.SolCatMethods = void 0;
const ixs = __importStar(require("./instructions"));
class SolCatMethods {
    constructor(ctx, ix) {
        this.ctx = ctx;
        this.ix = ix;
    }
    // Admin functions
    updateAdmin(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.updateAdmin(this.ctx.program, params);
            return this;
        });
    }
    withdrawFund(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.withdrawFund(this.ctx.program, params);
            return this;
        });
    }
    updateLockupVault(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.updateLockupVault(this.ctx.program, params);
            return this;
        });
    }
    updateFlexibleVault(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.updateFlexibleVault(this.ctx.program, params);
            return this;
        });
    }
    // User functions
    initUser(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.initUser(this.ctx.program, params);
            return this;
        });
    }
    initFlexibleAccount(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.initFlexibleAccount(this.ctx.program, params);
            return this;
        });
    }
    stake(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.stake(this.ctx.program, params);
            return this;
        });
    }
    withdraw(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.withdraw(this.ctx.program, params);
            return this;
        });
    }
    withdrawDelay(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.withdrawDelay(this.ctx.program, params);
            return this;
        });
    }
    claim(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.claim(this.ctx.program, params);
            return this;
        });
    }
    lockup(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.lockup(this.ctx.program, params);
            return this;
        });
    }
    unlock(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.unlock(this.ctx.program, params);
            return this;
        });
    }
}
exports.SolCatMethods = SolCatMethods;
class V2Methods {
    constructor(ctx, ix) {
        this.ctx = ctx;
        this.ix = ix;
    }
    // Admin functions
    updateAdmin(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.updateAdmin(this.ctx.program, params);
            return this;
        });
    }
    withdrawFund(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.withdrawFund(this.ctx.program, params);
            return this;
        });
    }
    withdrawRevenue(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.withdrawRevenue(this.ctx.program, params);
            return this;
        });
    }
    updateLockupVault(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.updateLockupVault(this.ctx.program, params);
            return this;
        });
    }
    updateFlexibleVault(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.updateFlexibleVault(this.ctx.program, params);
            return this;
        });
    }
    updateFee(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.updateFee(this.ctx.program, params);
            return this;
        });
    }
    initFlexibleVault(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.initFlexibleVault(this.ctx.program, params);
            return this;
        });
    }
    initLockupVault(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.initLockupVault(this.ctx.program, params);
            return this;
        });
    }
    // User functions
    initUser(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.initUser(this.ctx.program, params);
            return this;
        });
    }
    initFlexibleAccount(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.initFlexibleAccount(this.ctx.program, params);
            return this;
        });
    }
    stake(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.stake(this.ctx.program, params);
            return this;
        });
    }
    withdraw(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.withdraw(this.ctx.program, params);
            return this;
        });
    }
    withdrawDelay(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.withdrawDelay(this.ctx.program, params);
            return this;
        });
    }
    claim(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.claim(this.ctx.program, params);
            return this;
        });
    }
    lockup(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.lockup(this.ctx.program, params);
            return this;
        });
    }
    unlock(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.unlock(this.ctx.program, params);
            return this;
        });
    }
}
exports.V2Methods = V2Methods;
